module.exports = __webpack_public_path__ + "img/security_comm_fault_on.ae1c8be8.svg";